import { j as n } from "../../jsx-runtime-C5mzlN2N.js";
import { useBlocker as E } from "react-router-dom";
import { useState as M, useEffect as w } from "react";
import { UnsavedChangesContext as y } from "./UnsavedChangesContext.es.js";
import { useUnsavedChanges as ne } from "./UnsavedChangesContext.es.js";
import a from "styled-components";
import { b as B, M as F, a as S, c as L } from "../../ModalActions-DJ8mu8Ol.js";
import "../../components/Theme/themes.es.js";
import "../../palettes-Bw24w7AF.js";
import { getSpacings as m, getBreakpointMediaQuery as U } from "../../components/Theme/utils.es.js";
import "../../CssBaseline-Bp4jdUgb.js";
import { B as A } from "../../Button-DkQlhrIH.js";
import "../../styles-DaQVIHg4.js";
import { T as f } from "../../Typography-CGn3dGWy.js";
import { F as D } from "../../FileIcon-Co5mezSH.js";
import "../../components/FeaturedIcon/constants.es.js";
import { default as se } from "./useAutoSubmit.es.js";
import { parseSchemaFieldControls as re } from "./utils.es.js";
const T = "Discard unsaved changes", z = "Your changes have not been saved. Do you wish to discard these changes?", I = a(B)`
  display: flex;
  flex-direction: column;
  
  gap: ${m("xs")};
  div {
    padding-bottom: 16px;
  }
`, P = a.div`
  padding-top: ${m("lg")};
`, $ = a.div`
  display: flex;
  gap: ${m("lg")};

  ${U("max", "md")} {
    flex-direction: column-reverse;
  }
`, x = a(A)`
  width: 100%;
`, O = (d) => {
  const {
    isOpen: l,
    onClose: t,
    onConfirm: i
  } = d;
  return /* @__PURE__ */ n.jsxs(
    F,
    {
      isOpen: l,
      onClose: t,
      size: "md",
      children: [
        /* @__PURE__ */ n.jsx(
          S,
          {
            isCloseIconVisible: !0,
            onCloseIconClick: t,
            isDividerVisible: !1,
            children: /* @__PURE__ */ n.jsx(
              D,
              {
                variant: "light",
                color: "warning",
                iconProps: {
                  variant: "alert-triangle"
                }
              }
            )
          }
        ),
        /* @__PURE__ */ n.jsxs(I, { children: [
          /* @__PURE__ */ n.jsx(f, { size: "lg", weight: "semibold", children: T }),
          /* @__PURE__ */ n.jsx("div", { children: /* @__PURE__ */ n.jsx(f, { size: "md", weight: "regular", color: "tertiary", children: z }) })
        ] }),
        /* @__PURE__ */ n.jsx(L, { isDividerVisible: !1, children: /* @__PURE__ */ n.jsx(P, { children: /* @__PURE__ */ n.jsxs($, { children: [
          /* @__PURE__ */ n.jsx(
            x,
            {
              size: "lg",
              color: "gray",
              variant: "outlined",
              onClick: t,
              children: "Cancel"
            }
          ),
          /* @__PURE__ */ n.jsx(x, { size: "lg", onClick: i, children: "Confirm" })
        ] }) }) })
      ]
    }
  );
}, k = (d) => {
  const {
    children: l
  } = d, [t, i] = M([]), r = t.some((e) => e.isBlocked), g = (e) => {
    if (t.find(
      (s) => s.id === e.id
    )) {
      const s = t.map((u) => u.id === e.id ? e : u);
      i(s);
      return;
    }
    i((s) => [...s, e]);
  }, o = E((e) => {
    const {
      currentLocation: h,
      nextLocation: s
    } = e;
    return r && h.pathname !== s.pathname;
  }), p = o.state === "blocked", v = o.state === "proceeding", c = (e) => {
    r && e.preventDefault();
  };
  w(() => {
    var e;
    return p && !r ? (window.removeEventListener("beforeunload", c), (e = o == null ? void 0 : o.reset) == null || e.call(o)) : window.addEventListener("beforeunload", c), () => {
      window.removeEventListener("beforeunload", c);
    };
  }, [
    r,
    o
  ]);
  const C = () => {
    var e;
    i([]), (e = o == null ? void 0 : o.proceed) == null || e.call(o);
  }, j = () => {
    var e;
    (e = o == null ? void 0 : o.reset) == null || e.call(o);
  };
  return /* @__PURE__ */ n.jsxs(
    y.Provider,
    {
      value: {
        revalidateForms: g,
        formCollection: t,
        setFormCollection: i
      },
      children: [
        l,
        /* @__PURE__ */ n.jsx(
          O,
          {
            isOpen: p || v,
            onClose: j,
            onConfirm: C
          }
        )
      ]
    }
  );
};
export {
  k as UnsavedChangesProvider,
  re as parseSchemaFieldControls,
  se as useAutoSubmit,
  ne as useUnsavedChanges
};
